// eslint-disable-next-line import/no-anonymous-default-export
export default {
  build:    '86',
  commit:    '46dadc0bb98b52c4dfee6d7a6afc246c82041614',
  buildTime: '2024-02-15T19:10:23.014Z'
}